import { render, staticRenderFns } from "./_by-loja.table.vue?vue&type=template&id=89b6539c&scoped=true"
import script from "./_by-loja.table.vue?vue&type=script&lang=js"
export * from "./_by-loja.table.vue?vue&type=script&lang=js"
import style0 from "./_by-loja.table.vue?vue&type=style&index=0&id=89b6539c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b6539c",
  null
  
)

export default component.exports